export default "__VITE_ASSET__7e507ef6__"